<template>
    <div id="recipes-serp-root" class="recipes-serp-root">
        <div
            v-show="showFilterMenu"
            id="recipes-filter-menu-wrapper"
            class="recipesFilterMenuWrapper"
        >
            <div
                id="recipes-filter-overlay"
                class="recipesFilterOverlay"
                @click="closeFilterMenu()"
            ></div>
            <div
                id="recipes-filter-menu-inner-wrapper"
                class="recipesFilterMenuInnerWrapper"
            >
                <div id="filter-menu-top" class="filterMenuTop">
                    <div
                        id="filter-menu-close"
                        class="filterMenuClose"
                        @click="closeFilterMenu()"
                    >
                        <i class="fa fa-times-circle-o"></i>
                    </div>
                </div>
                <div id="filter-menu-mid" class="filterMenuMid">
                    <div id="filter-menu-logo" class="filterMenuLogo">
                        <img
                            id="header-logo-img"
                            class="headerLogoImage"
                            :src="'/assets/images/common/freshy_logo_w.png'"
                        />
                    </div>
                    <div id="filter-menu-title" class="filterMenuTitle">
                        Recipes
                    </div>
                </div>
                <div
                    class="menuItem"
                    v-for="(menu, index) in helper.MENUS"
                    :key="index"
                >
                    <div
                        class="menuItemTitle"
                        @click="openFilterSubMenu(menu.name)"
                    >
                        <div class="menuIconWrapper">
                            <img
                                :id="`menu-icon_${menu.name}`"
                                class="menuIcon"
                                :src="menu.icon"
                            />
                        </div>
                        <div class="menuTitleWrapper">
                            <div
                                :id="`menu-title_${menu.name}`"
                                class="menuTitle"
                            >
                                {{ menu.name }}
                            </div>
                        </div>
                    </div>
                    <!--DropDown Menu-->
                    <div
                        v-if="openFilterMenus.includes(menu.name)"
                        class="dropBox"
                    >
                        <div class="dropBoxInner">
                            <div class="dropRightCol">
                                <div class="filterOptionsOuterWrapper">
                                    <div
                                        class="filterOptions"
                                        v-if="
                                            submenu.model == 'resultCategory1'
                                        "
                                        v-for="(submenu, index) in menu.items"
                                        :key="index"
                                        @click="
                                            e =>
                                                e.target.classList.toggle(
                                                    'active'
                                                )
                                        "
                                    >
                                        <div
                                            :id="
                                                `filter-option-wrapper_${menu.name}-${submenu.value}`
                                            "
                                            class="filterOptionWrapper"
                                            :class="{
                                                selectedOption: currentSelectedFilters.includes(
                                                    submenu.value
                                                ),
                                            }"
                                        >
                                            <input
                                                hidden
                                                type="checkbox"
                                                :id="submenu.value"
                                                :value="submenu.value"
                                                v-model="currentSelectedFilters"
                                            />
                                            <label :for="submenu.value">{{
                                                submenu.value
                                            }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="recipes-serp-wrapper" class="recipesSerpWrapper">
            <div id="recipes-serp-top" class="recipesSerpTop">
                <div id="search-wrapper" class="searchWrapper">
                    <auto-complete-input
                        v-model="query"
                        ref="queryInput"
                        id="query-input"
                        class="queryInput"
                        :group="9"
                        :placeholder="branding.AutocompletePlaceholder"
                        @selected="onEnterSearch()"
                        @return="onEnterSearch()"
                        @iconClick="onEnterSearch()"
                        :dev="false"
                    />
                </div>
                <div
                    id="filter-menu-btn"
                    class="filterMenuBtn"
                    @click="showFilterMenu = !showFilterMenu"
                >
                    <i class="fa fa-bars"></i>
                </div>
            </div>
            <div
                id="recipes-serp-active-filters"
                class="recipesSerpActiveFilters"
            >
                <div
                    v-for="(filter, index) in resultCategory1"
                    :key="index"
                    :id="`active-filter_${index}`"
                    class="activeFilter"
                >
                    <div
                        class="activeFilterInnerWrapper"
                        @click="removeFilter(filter)"
                    >
                        <div class="activeFilterText">{{ filter }}</div>
                        <div class="activeFilterRemove">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div
                id="recipes-serp-results-wrapper"
                class="recipesSerpResultsWrapper"
            >
                <div v-if="hasSearchResults" class="serp-results">
                    <!--Left col-->
                    <div class="serp-results-left">
                        <div v-show="hasSearchResults" class="masonry">
                            <!--results-->
                            <div
                                class="srl has-image"
                                v-for="(result, index) in records"
                                :key="index"
                                @click.prevent="
                                    openUrl(result.url, true, false, false)
                                "
                            >
                                <div class="srl-container">
                                    <div
                                        v-if="result.resultFree"
                                        class="freeTag"
                                    >
                                        Free with Ads
                                    </div>
                                    <div class="srl-img-container">
                                        <div
                                            class="imgLoading"
                                            :id="`imgLoading_${index}`"
                                        >
                                            <i
                                                class="fa fa-spinner fa-pulse"
                                            ></i>
                                        </div>
                                        <div
                                            class="srl-img"
                                            :id="`srl-img_${index}`"
                                        >
                                            <img
                                                :id="`srl-img-loaded_${index}`"
                                                class="srl-img-loaded"
                                                :src="resultImage(result)"
                                                @error="errorImage($event)"
                                                @load="
                                                    onCardImageLoad(
                                                        index,
                                                        $event
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                    <div class="srl-info">
                                        <div class="srl-info-inner">
                                            <h3 class="srl-title">
                                                <a
                                                    :href="result.url"
                                                    target="_blank"
                                                    >{{
                                                        result.resultEntity
                                                    }}</a
                                                >
                                            </h3>
                                            <div
                                                v-show="result.domain"
                                                class="sug-domain"
                                            >
                                                {{ result.domain }}
                                            </div>
                                            <div
                                                v-show="result.description"
                                                class="srl-description"
                                            >
                                                {{ result.description[0] }}
                                            </div>
                                            <div
                                                class="cookTime"
                                                v-show="
                                                    helper.getFormattedIsoDuration(
                                                        result.resultCookTime
                                                    ) ||
                                                        helper.getFormattedIsoDuration(
                                                            result.resultTotalTime
                                                        )
                                                "
                                            >
                                                <b>Cook Time:</b>
                                                {{
                                                    helper.getFormattedIsoDuration(
                                                        result.resultCookTime
                                                    ) ||
                                                        helper.getFormattedIsoDuration(
                                                            result.resultTotalTime
                                                        )
                                                }}
                                            </div>
                                            <div
                                                class="cal"
                                                v-show="result.resultCalories"
                                            >
                                                <b>Caloires:</b>
                                                {{ result.resultCalories }}
                                            </div>
                                            <div
                                                v-show="result.resultCategory1"
                                                class="srl-cat"
                                            >
                                                <strong>Tags:</strong
                                                >{{ resultCategories(result) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--end of results-->
                        </div>
                        <!--Browse Panel-->
                        <!--End of left col-->
                    </div>
                </div>
                <!-- end of has results -->
                <div
                    v-else-if="searchCompleted && !hasSearchResults"
                    class="noResults"
                >
                    <div class="mobile-recipes-noresults">
                        Your search for "<span class="noresults-keyword">{{
                            enteredQuery
                        }}</span
                        >" did not match any recipe.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import queryString from "query-string";
import { documentReady } from "@/common";
import { CURRENT_HOST } from "@/urls";
import { clickEvent } from "@/analytics";
import { validatePop, verticals } from "@/pages/search/views/mixins/verticals";
import { SEARCH_API_URL } from "@/pages/search/views/recipes/urls";
import helper, {
    RECIPES_FILTER_IMAGE_URLS,
} from "@/pages/search/views/recipes/Helper";
import AutoCompleteInput from "@/components/autoCompleteInput/MobileAutoCompleteInput.vue";
import { getBranding } from "@/branding";

export default {
    mixins: [verticals],
    name: "serp",
    components: {
        "auto-complete-input": AutoCompleteInput,
    },
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            query: qs.q || "",
            showFilterMenu: false,
            resultCategory1: [],
            enteredResultCategory1: [],
            openFilterMenus: [],
            currentSelectedFilters: [],
            searchCompleted: false,
            trigger: 150,
            perPageNo: 12,
            maxPageNum: 10,
            helper,
            branding: getBranding(),
        };
    },
    mounted() {
        documentReady.then(async () => {
            this.initScroll();
            await this.handleSearchUrl();
            this.firstRunQuery = this.query;
            this.firstRunCount = this.totalRecords;
            this.firstLoad = false;
        });
    },
    watch: {},
    methods: {
        onCardImageLoad(index, event) {
            this.onImageLoad(index);
            try {
                const img = document.querySelector(`#srl-img_${index}`);
                img.style.display = "block";
            } catch (e) {
                this.errorImage(event);
            }
        },
        errorImage(event) {
            try {
                const target = event.originalTarget || event.target;
                const randomNum = Math.floor(Math.random() * Math.floor(3)) + 1; // 1 2 or 3
                target.src = `/assets/images/recipes/placeholder_${randomNum}.png`;
                target.style.width = "auto";
            } catch (e) {
                console.log(e);
            }
        },
        blurInputFocus() {
            this.$refs.queryInput.blur();
        },
        openFilterMenu() {
            (this.showFilterMenu = true),
                (this.currentSelectedFilters = this.resultCategory1);
        },
        closeFilterMenu() {
            let diff = false;
            // Check for differnce in arrays
            if (
                this.resultCategory1.length !=
                this.currentSelectedFilters.length
            ) {
                // length difference, know that there is a change without checking elements
                diff = true;
            } else if (
                this.resultCategory1.length ==
                    this.currentSelectedFilters.length &&
                this.resultCategory1.length > 0 &&
                this.currentSelectedFilters.length > 0
            ) {
                // length is the same and more than 0, have to check each element to try and find difference
                for (const i in this.currentSelectedFilters) {
                    if (
                        !this.resultCategory1.includes(
                            this.currentSelectedFilters[i]
                        )
                    ) {
                        // we know an element exists in the new filters array that was not in old array
                        diff = true;
                        break;
                    }
                }
            }

            if (diff) {
                this.resultCategory1 = this.currentSelectedFilters;
                this.doSearch();
            }

            this.showFilterMenu = false;
        },
        openFilterSubMenu(menu) {
            if (this.openFilterMenus.includes(menu)) {
                this.openFilterMenus = this.openFilterMenus.filter(
                    (val, index, arr) => val != menu
                );
            } else this.openFilterMenus.push(menu);
        },
        async removeFilter(filter) {
            this.resultCategory1 = this.resultCategory1.filter(
                el => el != filter
            );
            await this.doSearch();
        },
        resetAllFilters() {
            this.resultCategory1 = [];
        },
        resultCategories(result) {
            const cat = [];
            if (result.resultCategory1) cat.push(result.resultCategory1);
            return cat.join(", ");
        },
        async getNextResults(page) {
            let check = true;
            if (page < this.totalPages && !this.isFetching) {
                this.currentPage = page;

                const newRecords = await this.makeNextCall();

                if (newRecords) {
                    this.records = this.records.concat(newRecords);
                }
                if (this.currentPage >= this.totalPages - 1) {
                    this.isEnd = true;
                }
                check = true;
            } else check = false;

            this.isFetching = false;
            return check;
        },
        async makeNextCall() {
            this.isFetching = true;
            const body = this.currentRequest;
            body.pageNo = this.currentPage;

            const recordsReq = await fetch(`${CURRENT_HOST}${SEARCH_API_URL}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (recordsReq.ok) {
                const recordsRes = await recordsReq.json();
                return recordsRes.main.records;
            }
            this.isFetching = false;
        },
        onEnterSearch() {
            if (
                (this.query &&
                    this.enteredQuery &&
                    this.query != this.enteredQuery) ||
                (this.query && !this.enteredQuery)
            ) {
                const url = new URL(window.location.href);
                if (this.query) url.searchParams.set("q", this.query);
                else url.searchParams.delete("q");
                const title = `Freshy Recipe Search - ${this.query}`;
                document.title = title;
                window.history.pushState(
                    { path: url.toString() },
                    title,
                    url.toString()
                );
            }

            this.freshQuerySearch();
        },
        async freshQuerySearch(fromUrl = false) {
            // close first run

            // is mobile, so force input to lose focus
            this.blurInputFocus();

            if (!fromUrl) this.whichPop = false;

            this.badSearch = false;
            this.resetAllFilters();
            this.enteredQuery = this.query;
            const url = new URL(window.location.href);
            if (this.enteredQuery) url.searchParams.set("q", this.enteredQuery);
            else url.searchParams.delete("q");
            window.history.replaceState(
                { path: url.toString() },
                `Freshy Web Search - ${this.enteredQuery}`,
                url.toString()
            );

            await this.doSearch(fromUrl);
        },
        async doSearch() {
            window.scrollTo(0, 0);
            const term = this.enteredQuery || "*";

            this.records = [];
            this.isEnd = false;
            this.emptySearch = false;
            this.currentPage = 0;

            this.searchCompleted = false;

            const body = {
                group: 9,
                q: term,
                perPage: this.perPageNo,
                pageNo: this.currentPage,
            };

            if (this.filterList) body.filters = this.filterList;

            // ads call, do not wait
            this.doAdSearch(term);

            const recordsReq = await fetch(`${SEARCH_API_URL}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });
            if (recordsReq.ok) {
                const recordsRes = await recordsReq.json();

                if (recordsRes && recordsRes.main) {
                    this.tags = [];
                    if (term && recordsRes.main.records) {
                        this.totalPages = recordsRes.main.numPages;
                        this.totalRecords = recordsRes.main.total;
                        this.records = recordsRes.main.records;
                        // save current body for infinity scroll / pagination
                        this.currentRequest = body;

                        this.searchTerm = "";
                        if (this.enteredQuery && this.enteredQuery != "*")
                            this.searchTerm = this.enteredQuery;
                        else this.searchTerm = "";
                    }
                }
                this.searchCompleted = true;
            }
        },
        initScroll() {
            const root = document.querySelector("#root");

            const scrollEv = () => {
                // OFFSET TO TRIGGER, HAVE SET TO OFFSET HEIGHT
                const OFFSET = root.offsetHeight;

                if (
                    root.scrollTop >=
                        root.scrollHeight - (root.offsetHeight + OFFSET) &&
                    !this.isFetching &&
                    this.currentPage < this.maxPageNum
                ) {
                    this.getNextResults(this.currentPage + 1);
                } else if (
                    root.scrollTop >=
                    root.scrollHeight - (root.offsetHeight + OFFSET / 2)
                ) {
                }
            };

            try {
                root.removeEventListener("scroll", scrollEv);
            } catch (e) {
                console.error("ERROR SCROLL: ", e);
            }
            // Add load on scroll

            root.addEventListener("scroll", scrollEv);
        },
    },
    computed: {
        isFiltered() {
            return this.resultCategory1.length;
        },
        filterList() {
            const output = {};

            // Check that it exists (MUST HAVE)
            output.resultEntity = { exists: true };
            // filter categories
            if (this.resultCategory1 && this.resultCategory1.length) {
                output.resultCategory1 = this.resultCategory1;
            }
            this.enteredResultCategory1 = this.resultCategory1;
            // ADD OTHER FILTERS HERE

            output.resultImage = { not: RECIPES_FILTER_IMAGE_URLS };
            // filter by recipe_quality
            output.recipe_quality = { term: "good" };

            if (output) return output;
            return false;
        },
    },
};
</script>
<style>
@import "../common/common.css";
@import "./recipes.css";
</style>
